export const HYPERTENSION_DISORDERS = {
  id: 'hypertensive_disorders',
  label: 'Disordini ipertensivi (ipertensione, preeclampsia, eclampsia, sindrome HELLP)',
};
export const GESTATIONAL_DIABETES = { id: 'gestational_diabetes', label: 'Diabete gestazionale' };
export const INFECTION = {
  id: 'infection',
  label: 'Infezione (es.: CMV, toxoplasma,sifilide, etc.)',
};
export const MENTAL_DISORDERS = {
  id: 'mental_disorders',
  label: 'Disturbi psichici (psicotici, dell’umore, d’ansia, da condizione medica generale)',
};
export const ADDICTIONS = { id: 'addictions', label: 'Dipendenze' };
export const NEW_ONSET_SYSTEMIC_OR_TUMOR_PATHOLOGY = {
  id: 'new_onset_systemic_or_tumor_pathology',
  label: 'Comparsa ex novo di patologia sistemica e/o tumorale',
};
export const OTHER = { id: 'other', label: 'Altro (interventi chirurgici pregressi, altro)' };
